import Timeslot, { Conflict } from "app/models/timeslot"
import { Action, Types } from "./timeslots.actions"

export type TimeslotsState = {
  data: Timeslot[] | undefined
  errors: {}
  loading: boolean
  timeslot: Timeslot[] | undefined
}

const initialState: TimeslotsState = {
  data: [],
  errors: {},
  loading: false,
  timeslot: undefined,
}

export default (state = initialState, action: Action): TimeslotsState => {
  switch (action.type) {
    case Types.POST:
      return {
        ...state,
        loading: true,
      }

    case Types.POST_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case Types.POST_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.GET_BY_ID:
      return {
        ...state,
        loading: true,
      }

    case Types.GET_BY_ID_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      }

    case Types.GET_BY_ID_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.PATCH_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case Types.PATCH_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.PATCH_CONFLICTS:
      return {
        ...state,
        loading: true,
      }

    case Types.PATCH_CONFLICTS_SUCCESS: {
      const updatedConflictData = state.data?.map(ts => ({
        ...ts,
        conflicts:
          (ts.conflicts &&
            ts.conflicts.map((conflict: Conflict) => {
              if (conflict.id === action.payload.data.id) {
                return action.payload.data
              }
              return conflict
            })) ||
          [],
      }))

      return {
        ...state,
        loading: false,
        data: updatedConflictData,
      }
    }

    case Types.PATCH_CONFLICTS_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    default:
      return state
  }
}
